import { useEffect, useState } from "react";
import { injectIntl } from 'react-intl';
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons";
import './Dropdown.scss';

function UIDropdown(props) {
    const [current, setCurrent] = useState(props.data[0]);
    const [data, setData] = useState(props.data);

    function onDDItemClick(item) {
        props.onDDClick(item);
        setTimeout(() => setCurrent(item), 100);
    }

    useEffect(() => {
        if (props.data && props.data.length > 0) {
            setData(props.data);
            if (props.current) {
                if (typeof props.current == 'string') {
                    let found = props.data.find(item => item.value === props.current
                        || item.name === props.current);
                    if (found) setCurrent(found);
                } else {
                    setCurrent(props.current);
                }
            }
            else setCurrent(props.data[0]);
        }
    }, [props.data])

    if (data && data.length > 0) {
        return (
            <div className="uidropdown-box">
                <div className="uidropdown-required-wrapper">
                    {(props.required && !props.withLabel) && <FontAwesomeIcon icon={faStar} />}
                </div>
                <Dropdown className={`uidropdown ${props.error ? 'dd-error' : ''}`}>
                    <Dropdown.Toggle className="uidropdown-top">
                        <div> {current.intl ? props.intl.formatMessage({ id: current.intl }) : current.value}</div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {data.map((item, i) => (
                            <Dropdown.Item key={`dropdownMenuItem${i}`}
                                onClick={onDDItemClick.bind(null, item)}>
                                {item.intl ? props.intl.formatMessage({ id: item.intl }) : item.value}
                            </Dropdown.Item>))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>)
    }


    return (<div></div>)
}

export default injectIntl(UIDropdown);